import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CategoriaInstituicaoEnsinoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all categories
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: any[] }>(`${this.path}/getAllCategoriaInstituicaoEnsino`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get category by ID
  public show(id: string): Observable<any> {
    return this.apiService.get<{ data: any, retorno: any }>(`${this.path}/getCategoriaInstituicaoEnsinoById/${id}`).pipe(
      map(response => response.data)
    );
  }

  // Create new category
  public store(data: any): Observable<any> {
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddCategoriaInstituicaoEnsino`, data)
      .pipe(
        map((response) => response.object)
      );
  }

  // Update existing category
  public update(data: any, id: string): Observable<any> {
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateCategoriaInstituicaoEnsino/${id}`, data)
      .pipe(
        map((response) => response.object)
      );
  }

  // Delete existing category
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteCategoriaInstituicaoEnsinoById/${id}`);
  }
}
